import { domToReact } from 'html-react-parser';

import { parserOptions } from '@commons/components/RichText';
import type { Template } from '@commons/components/RichText/templates';
import Flex from '@commons/containers/Flex';

import styles from './TwoColumns.module.scss';

/**
 * Two columns CKEditor template.
 *
 * @param nodes - An array of DOM nodes to render.
 *
 * @returns A rendered React component.
 */

const TwoColumnsTemplate: Template = ({ nodes }) => (
  <Flex gap="md" width={12} direction={{ xs: 'column', md: 'row' }} className={styles.twoColumns}>
    {domToReact(nodes, parserOptions)}
  </Flex>
);

export default TwoColumnsTemplate;
